import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';

class ConfirmationAmount extends Component {
  render() {
    return (
      <HeadingText
        size="sm"
        className="text-center"
        dangerouslySetInnerHTML={{ __html: this.props.message }}
        style={{ margin: '24px auto' }}
      ></HeadingText>
    );
  }
}
export default ConfirmationAmount;

ConfirmationAmount.propTypes = {
  message: PropTypes.string,
};
